import baseApi from '../utils/ApiUtils';

const setAuthUser = (response, dispatch) => {
  const token = {
    access_token: response?.data?.data?.access,
    refresh_token: response?.data?.data?.refresh,
  };
  localStorage.setItem('token', JSON.stringify(token));
  localStorage.setItem('user', JSON.stringify(response.data?.data));
  localStorage.setItem('role', JSON.stringify(response?.data?.data));
  dispatch({type: 'LOGIN', payload: response.data?.data});
  dispatch({type: 'ROLE', payload: response.data?.data});
};

export const authServices = (method, url, payload, dispatch, params = null) => {
  return baseApi(url, method, params, payload).then(response => {
    if (response.data) {
      setAuthUser(response, dispatch);
    }
    return response.data;
  });
};

export const invitationServices = (method, payload = null, params = null) => {
  return baseApi(`/accounts/register-email/`, method, params, payload).then(response => {
    return response.data;
  });
};

/**
 * resend otp api
 * */
export const otpServices = (payload = null) => {
  return baseApi('/resend_otp', 'put', null, payload).then(response => {
    return response.data;
  });
};

export const logout = (dispatch) => {
  return baseApi(`/accounts/logout/`, 'post').then(response => {
    localStorage.clear();
    sessionStorage.clear();
    dispatch({type: 'LOGOUT'});
    return response;
  });
};

/**
 * NDI api
 * */

export const NDIProofRequestApi = (method, payload = null, params = null) => {
  return baseApi(`/ndi/proof_requests/`, method, params, payload).then(response => {
    return response.data;
  })
};

export const NDITokenApi = (method, payload = null, params = null) => {
  return baseApi(`/ndi/token/`, method, params, payload).then(response => {
    return response.data;
  });
};
